import React from 'react';
import Marquee from 'react-fast-marquee';
interface Client {
  name: string;
  url: string;
  logo?: string;
}
const clients: Client[] = [{
  name: 'DPD Romania',
  url: 'https://www.dpd.com/ro/en/',
  logo: 'https://www.dpd.com/wp-content/themes/DPD_NoLogin/images/DPD_logo_redgrad_rgb_responsive.svg'
}, {
  name: 'Oradea Tech Hub',
  url: 'https://www.coworkbooking.com/europe/romania/oradea/oradea-tech-hub',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wAm2qJE4KbMhcL1AdTXKyS/image.png'
}, {
  name: 'Pădurea de Mâine',
  url: 'https://padureademaine.ro/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kCWFJ6FprkrmxaYL6aGZm4/image.png'
}, {
  name: 'Cargus',
  url: 'https://www.cargus.ro/',
  logo: 'https://www.cargus.ro/wp-content/uploads/CG_LOGO_OGB_RGB-1.svg'
}, {
  name: 'Cegeka',
  url: 'https://www.cegeka.com/ro/',
  logo: 'https://www.cegeka.com/hubfs/Cegeka_Logo.svg'
}, {
  name: 'AROBS Transilvania Software',
  url: 'https://arobs.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4ZLk8Y5fHKayjrN2f7eGx9/image.png'
}];
export const ClientLogos = () => {
  return <section className="py-16" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="text-center mb-12" data-id="element-116">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-117">
            Proven Results, Now Powered by AI
          </h2>
          <p className="text-lg text-gray-600" data-id="element-118">
            Our expertise helped scale 40+ businesses. Now it's built into every
            campaign.
          </p>
        </div>
        <Marquee gradient={false} speed={40} pauseOnHover={true} className="py-4" data-id="element-119">
          {clients.map(client => <a key={client.name} href={client.url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center px-12 transition-all duration-300 group" data-id="element-120">
              <div className="text-center w-full" data-id="element-121">
                {client.logo ? <img src={client.logo} alt={client.name} className="max-h-20 w-auto mx-auto object-contain transition-all duration-300 group-hover:scale-110 mix-blend-multiply" style={{
              filter: 'contrast(1.1) brightness(1.05)'
            }} data-id="element-122" /> : <div className="text-base font-bold text-gray-500 group-hover:text-[#6366f1] transition-colors" data-id="element-123">
                    {client.name}
                  </div>}
              </div>
            </a>)}
        </Marquee>
      </div>
    </section>;
};